import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'

import { unregisterPush } from '@/features/push/pushRegistration'

import { authApi } from '../api/authApi'
import { authBroadcast } from '../lib/authBroadcast'
import { refreshScheduler } from '../lib/refreshScheduler'
import { useAuthStore } from '../store/authStore'

export function useLogoutMutation() {
  const qc = useQueryClient()
  const navigate = useNavigate()
  return useMutation<void, unknown, void>({
    mutationFn: () => authApi.logout().catch(() => undefined),
    onSettled: () => {
      void unregisterPush() // borra el device token (native-only, no-op en web)
      useAuthStore.getState().clear()
      refreshScheduler.cancel()
      qc.clear()
      authBroadcast.publish('logout')
      // Redirige a home tras cerrar sesión — quedarse en /profile o
      // /sessions/new tras logout fuerza al usuario a salir manualmente
      // de un sitio donde ya no tiene contexto.
      void navigate('/', { replace: true })
    },
  })
}
